
import HighCharts from 'highcharts';

export default {
  props: ['stockCodeLists', 'stockNews'],
  data() {
    return {
      hasRelated: 1,
      data: null,
      newsStates: {},
      stockData: [],
      isNewsPage: false,
    };
  },
  mounted() {
    this.getStockChar();
  },
  created() {
    if (
      this.$route.name === 'news-id' ||
      this.$route.name === 'live-id' ||
      this.$route.name === 'lang-news-id'
    ) {
      this.isNewsPage = true;
    }
  },
  methods: {
    getStockChar() {
      if (this.stockCodeLists) {
        for (let i = 0; i < this.stockCodeLists.length; i++) {
          const fifteenClosePrice =
            this.stockCodeLists[i].fifteenClosePrice || '';
          const stockNumList = [];
          this.stockData = fifteenClosePrice.split(',');
          this.stockData.forEach(ele => {
            stockNumList.push(Number(ele));
          });
          HighCharts.chart('container' + i, {
            chart: {
              width: 44,
              height: 36,
              type: 'line',
              // spacingLeft: 40
            },
            colors: [
              this.stockCodeLists[i].change > 0
                ? '#FF5A5A'
                : this.stockCodeLists[i].change < 0
                ? '#06D564'
                : '#999999',
            ],
            tooltip: {
              enabled: false,
            },
            credits: {
              enabled: false,
            },
            title: {
              text: null,
            },
            exporting: {
              enabled: false,
            },
            xAxis: {
              tickWidth: 0,
              lineWidth: 0,
              labels: {
                enabled: false,
              },
              credits: {
                enabled: false,
              },
              title: {
                text: null,
              },
              exporting: {
                enabled: false,
              },
            },
            yAxis: {
              title: {
                text: '',
              },
              tickWidth: 0,
              lineWidth: 0,
              gridLineWidth: 0,
              labels: {
                enabled: false,
              },
            },
            legend: {
              layout: 'vertical',
              floating: true,
              backgroundColor: '#fff',
              align: 'center',
              verticalAlign: 'vertical',
              y: 45,
              x: 35,
              enabled: false,
            },
            plotOptions: {
              series: {
                marker: {
                  enabled: false,
                  lineColor: '',
                },
              },
            },
            series: [
              {
                name: this.stockCodeLists.name,
                data: stockNumList,
              },
            ],
          });
        }
      }
    },
  },
};
